import React, { Fragment, useContext } from 'react';
import {AuthContext} from '../../AuthContext';
import {
    Empty
} from 'antd';
import _ from 'lodash';

import Header from './header';
import LeftSidebar from './leftSidebar';

const Index = ({
    children
}) => {

    const { userData } = useContext(AuthContext);
    const isReportViewer = _.isEqual(userData.role, 'Reports Viewer');
    return (
        <Fragment>
            <Header />
            {
                !isReportViewer &&
                <LeftSidebar />
            }
            <section className={isReportViewer ? null : 'section-container'}>
                { children ? children : <Empty/> }
            </section>
        </Fragment>
    );
};

export default Index;